import { render, staticRenderFns } from "./PremiumConsult.vue?vue&type=template&id=32a69e00&"
import script from "./PremiumConsult.vue?vue&type=script&lang=js&"
export * from "./PremiumConsult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports